<template>
    <b-container fluid>
        <b-row>
            <b-col>
                <app-meeting-filters @filter="onFilter" @clear="onClearFilters"></app-meeting-filters>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <app-data-table :items="meetings" :fields="fields">
                    <template #cell(meeting_date)="{ item }">
                        {{ item.meeting_date | datetime }}
                    </template>
                    <template #cell(meeting_date_human)="{ item }">
                        {{ moment().to(item.meeting_date) }}
                    </template>
                </app-data-table>
            </b-col>
        </b-row>
    </b-container>
</template>
<script>
import appMeetingFilters from './MeetingFilters'
export default {
    components: {
        appMeetingFilters
    },
    data: () => ({
        meetings: [],
        fields,
        filters: ''
    }),
    computed: {
        //
    },
    methods: {
        async loadNextMeetings() {
            const { data } = await this.$repo.get( 'monitoring/upcoming-meetings', this.filters )
            this.meetings = data
        },
        onFilter(filters) {
            this.filters = filters
            this.loadNextMeetings()
        },
        onClearFilters() {
            this.filters = ''
            this.loadNextMeetings()
        }
    },
    created() {
        this.loadNextMeetings()
    },
}

const fields = [
    {
        key: 'id',
        label: 'ID',
    },
    {
        key: 'name',
        label: 'Reunión',
    },
    {
        key: 'code',
        label: 'Código',
    },
    {
        key: 'meeting_type.name',
        label: 'Tipo',
    },
    {
        key: 'host.name',
        label: 'Moderador',
    },
    {
        key: 'venue.unit.name',
        label: 'Unidad',
    },
    {
        key: 'venue.unit.client.name',
        label: 'Cliente',
    },
    {
        key: 'meeting_date',
        label: 'Fecha',
    },
    {
        key: 'meeting_date_human',
        label: 'En',
    },
    {
        key: 'meeting_participants_count',
        label: 'Invitaciones',
    },
]
</script>
